import { panelType } from '@bimser/common';
import { BCButton, BCCard, BCList, BCSkeleton, ContentType, findMessage } from '@bimser/components';
import { MLHelper } from '@bimser/core';
import IconHover from '@bimser/icons/16/sub-menu-arrow';
import IconAnnouncement from '@bimser/icons/32/announcement';
import { IAnnouncement } from '../../../announcements/entities';
import Style from '../../assets/style.scss';
import IAnnouncementsProps from '../../entities/widgets/IAnnouncementsProps';
import { formatDates } from '../../utils';
import classNames from 'classnames/bind';
const cx = classNames.bind(Style);

const emptyView = require('../../../../assets/announcements-empty.svg');

export default (props: IAnnouncementsProps) => {
	const onClickAnnouncement = (item: IAnnouncement) => {
		props.onClickAnnouncement({
			panelId: props.panelId,
			panelType: panelType.startupLayout,
			data: item
		});
	};

	const onClickAllAnnouncements = () => {
		props.onClickAllAnnouncements({
			panelId: props.panelId,
			panelType: panelType.startupLayout,
			data: '#Recent'
		});
	};

	const renderCustomEmpty = () => (
		<div
			data-selenium-id="dashboardAnnouncementsEmptyView"
			className={cx({ emptyView: true, inCard: true })}
		>
			<img
				src={emptyView.default}
				className={Style.emptyViewImg}
			/>
			<span className={Style.emptyViewTitle}>{findMessage.get('102967')}</span>
			<span className={Style.emptyViewDesc}>{findMessage.get('102968')}</span>
		</div>
	);

	const renderItem = (item: IAnnouncement) => (
		<div
			className={Style.announcementItemContainer}
			onClick={() => onClickAnnouncement(item)}
		>
			<div className={Style.announcementItem}>
				<div className={Style.announcementItemIcon}>
					<IconAnnouncement
						width="28px"
						height="28px"
					/>
				</div>
				<div className={Style.announcementItemText}>
					<span className={cx({ announcementItemName: true, unRead: !item.isViewed })}>
						{MLHelper.getMLText(item.subject)}
					</span>
					<span className={Style.announcementItemCreateInfo}>
						{formatDates(item.modifiedAt ? item.modifiedAt : item.createdAt)}
					</span>
				</div>
			</div>
			<IconHover className={Style.iconHover} />
		</div>
	);

	const renderHeader = (
		<div className={Style.announcementsHeader}>
			<span className={Style.widgetHeader}>{findMessage.get('101048')}</span>
			{props.data && (
				<BCButton
					seleniumId="dashboardAnnouncementsShowAllButton"
					ghost
					type="primary"
					size="small"
					onClick={onClickAllAnnouncements}
				>
					{findMessage.get('102977')}
				</BCButton>
			)}
		</div>
	);

	return (
		<BCCard
			bordered={false}
			className={Style.announcementsContainer}
			title={renderHeader}
			seleniumId="dashboardAnnouncementsCard"
		>
			<BCSkeleton
				loadingStatus={props.loading}
				contentType={ContentType.DashboardAnnouncementsList}
			>
				<BCList
					bordered={false}
					dataSource={props.data}
					customEmpty={renderCustomEmpty()}
					renderItem={renderItem}
					className={Style.announcementsList}
				/>
			</BCSkeleton>
		</BCCard>
	);
};
